import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ProgramsSection } from './components/ProgramsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ApplySection } from './components/ApplySection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <Toaster position="top-center" richColors />
        <Navbar />
        <main>
          <HeroSection />
          <AboutSection />
          <ProgramsSection />
          <BenefitsSection />
          <ApplySection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
